import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FaEye, FaBullseye, FaHeart } from 'react-icons/fa';
import './Vision.css';

const Vision = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 }
    }
  };

  const visionItems = [
    {
      icon: FaEye,
      title: 'Our Vision',
      description: 'To be the global leader in innovative software solutions, empowering businesses to thrive in the digital age through cutting-edge technology and unparalleled expertise.'
    },
    {
      icon: FaBullseye,
      title: 'Our Mission',
      description: 'To deliver exceptional software solutions that exceed expectations, foster long-term partnerships, and drive measurable success for our clients worldwide.'
    },
    {
      icon: FaHeart,
      title: 'Our Values',
      description: 'Innovation, integrity, excellence, and customer-centricity form the foundation of everything we do. We believe in building trust through transparency and delivering quality without compromise.'
    }
  ];

  return (
    <section className="vision" id="vision" ref={ref}>
      <div className="vision-container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <span className="section-tag">Who We Are</span>
          <h2 className="section-title">Our Vision & Values</h2>
          <p className="section-description">
            Driven by passion, guided by purpose, and committed to excellence
          </p>
        </motion.div>

        <motion.div
          className="vision-grid"
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          {visionItems.map((item, index) => (
            <motion.div
              key={index}
              className="vision-card"
              variants={itemVariants}
              whileHover={{ y: -10, transition: { duration: 0.3 } }}
            >
              <div className="vision-icon">
                <item.icon />
              </div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
              <div className="card-glow"></div>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          className="vision-stats"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.8 }}
        >
          <div className="stat-box">
            <motion.h3
              initial={{ opacity: 0, scale: 0 }}
              animate={inView ? { opacity: 1, scale: 1 } : {}}
              transition={{ duration: 0.6, delay: 1 }}
            >
              99%
            </motion.h3>
            <p>Client Satisfaction</p>
          </div>
          <div className="stat-box">
            <motion.h3
              initial={{ opacity: 0, scale: 0 }}
              animate={inView ? { opacity: 1, scale: 1 } : {}}
              transition={{ duration: 0.6, delay: 1.2 }}
            >
              98%
            </motion.h3>
            <p>Response Rate</p>
          </div>
          <div className="stat-box">
            <motion.h3
              initial={{ opacity: 0, scale: 0 }}
              animate={inView ? { opacity: 1, scale: 1 } : {}}
              transition={{ duration: 0.6, delay: 1.4 }}
            >
              100%
            </motion.h3>
            <p>On-Time Delivery</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Vision;
